<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToggle } from '@vueuse/core';
import { useStoreGetters, useMapGetter } from 'dashboard/composables/store';

import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import CampaignLayout from 'dashboard/components-next/Campaigns/CampaignLayout.vue';
import CampaignList from 'dashboard/components-next/Campaigns/Pages/CampaignPage/CampaignList.vue';
import LINECampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/LINECampaign/LINECampaignDialog.vue';
import ConfirmDeleteCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/ConfirmDeleteCampaignDialog.vue';
import LINECampaignEmptyState from 'dashboard/components-next/Campaigns/EmptyState/LINECampaignEmptyState.vue';

const { t } = useI18n();
const getters = useStoreGetters();

const selectedCampaign = ref(null);
const [showLINECampaignDialog, toggleLINECampaignDialog] = useToggle();

const uiFlags = useMapGetter('campaigns/getUIFlags');
const isFetchingCampaigns = computed(() => uiFlags.value.isFetching);

const confirmDeleteCampaignDialogRef = ref(null);

const LINECampaigns = computed(() =>
  getters['campaigns/getCampaignsByChannelTypes'].value(['Channel::Line'])
);

const hasNoLINECampaigns = computed(
  () => LINECampaigns.value?.length === 0 && !isFetchingCampaigns.value
);

const handleDelete = campaign => {
  selectedCampaign.value = campaign;
  confirmDeleteCampaignDialogRef.value.dialogRef.open();
};
</script>

<template>
  <CampaignLayout
    :button-label="t('CAMPAIGN.LINE.NEW_CAMPAIGN')"
    :header-title="t('CAMPAIGN.LINE.HEADER_TITLE')"
    @click="toggleLINECampaignDialog()"
    @close="toggleLINECampaignDialog(false)"
  >
    <template #action>
      <LINECampaignDialog
        v-if="showLINECampaignDialog"
        @close="toggleLINECampaignDialog(false)"
      />
    </template>
    <div
      v-if="isFetchingCampaigns"
      class="flex items-center justify-center py-10 text-n-slate-11"
    >
      <Spinner />
    </div>
    <CampaignList
      v-else-if="!hasNoLINECampaigns"
      :campaigns="LINECampaigns"
      @delete="handleDelete"
    />
    <LINECampaignEmptyState
      v-else
      :subtitle="t('CAMPAIGN.LINE.EMPTY_STATE.SUBTITLE')"
      :title="t('CAMPAIGN.LINE.EMPTY_STATE.TITLE')"
      class="pt-14"
    />
    <ConfirmDeleteCampaignDialog
      ref="confirmDeleteCampaignDialogRef"
      :selected-campaign="selectedCampaign"
    />
  </CampaignLayout>
</template>
